module.exports = __webpack_public_path__ + "img/food9.c7d20a3c.jpeg";